module.exports = __webpack_public_path__ + "static/sonrisa_icon.530aac6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/sonrisa_icon.png
// module id = 436
// module chunks = 35783957827783